<template>
  <div class="tab-bar">
    <ul>
			<li>
				<router-link :to="{ name: 'user_list' }" exact>ユーザ一覧</router-link>
			</li>
			<li>
				<router-link :to="{ name: 'non_user_list' }" exact>非表示</router-link>
			</li>
    </ul>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
  },
}
</script>
